import { configureStore } from '@reduxjs/toolkit'
import flightSlice from './flightSlice'
import userSlice from './userSlice'
export const store = configureStore({
  reducer: { flightSlice, userSlice },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch